import React from 'react';
import './TabDescription.less';
import './TabsCommon.less';

const content = [
  { title: 'Цель и направления деятельности консорциума', field: 'goal' },
  { title: 'Результаты деятельности консорциума', field: 'results' },
  { title: 'Общие характеристики и статус консорциума', field: 'descr' },
];

export default function TabDescription(props) {
  return (
    <div className="tabs-common tab-description">
      {content.map((item, i) => (
        <article key={i}>
          <h4>{item.title}</h4>
          {/* eslint-disable-next-line react/no-danger */}
          <p dangerouslySetInnerHTML={{ __html: (props.data[item.field] || '').replace(/\n/gi, '<br>') }} />
        </article>
      ))}
    </div>
  );
}
